import {Box, Link} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileImport} from '@fortawesome/pro-duotone-svg-icons';
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type {ArticleUrlProps} from "@/src/_types/Article/article-sidebar";
import NextLink from "next/link";

export default function ArticleCitationFiles(
    {articleUrl}: { articleUrl: ArticleUrlProps }
) {
    return (
        <Box>
            <Link
                display="block"
                href={`${articleUrl.path}/${articleUrl.slug}.enw`}
            >
                <SpanTypography mr={.25}>
                    <FontAwesomeIcon
                        icon={faFileImport}
                    />
                </SpanTypography>
                <SpanTypography
                    color="primary.main"
                >
                    Import into EndNote
                </SpanTypography>
            </Link>
            <Link
                display="block"
                href={`${articleUrl.path}/${articleUrl.slug}.bib`}
            >
                <SpanTypography mr={.25}>
                    <FontAwesomeIcon
                        icon={faFileImport}
                    />
                </SpanTypography>
                <SpanTypography
                    color="primary.main"
                >
                    Import into BibTex
                </SpanTypography>
            </Link>
        </Box>
    );
}